import {EnquiryByIdAndChassisNumber, EnquiryByQrCode, SearchInput} from '../../Config/dataModel';
import {authRequest, request} from './request';

const enquiryByIdAndChassisNumber = (data: EnquiryByIdAndChassisNumber) => {
    return request({
        url: '/public/searchByIdAndChassisNumber',
        method: 'PUT',
        data
    });
};

const enquiryByQrCode = (data: EnquiryByQrCode) => {
    return request({
        url: '/public/searchByQrCode',
        method: 'PUT',
        data
    });
};

const search = (data: SearchInput) => {
    return authRequest({
        url: '/coverNote/search',
        method: 'PUT',
        data
    });
};

const enquiryAPI = {enquiryByIdAndChassisNumber, enquiryByQrCode, search};

export default enquiryAPI



// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/enquiryAPI.ts